// extracted by mini-css-extract-plugin
export default {"buttonToAnswerQuestion":"L5-z","disabled":"M5-z","seeAllAnswers":"N5-z"};